import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, ChevronLeft } from "lucide-react";
import AdminUsers from "./AdminUsers";

export default function AdminCandidateUsers() {
  return (
    <>
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-8 pb-0">
        <div className="flex items-center gap-1.5 font-mono text-[10px] text-muted-foreground mb-2">
          <Link to="/admin" className="hover:text-foreground flex items-center gap-1">
            <ChevronLeft className="w-3 h-3" /> Admin
          </Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-foreground">Candidate Users</span>
        </div>
      </div>
      <AdminUsers defaultRole="candidate" pageTitle="Candidate Users" />
    </>
  );
}
